<script setup>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const logout = () => {
  store.dispatch('logout');
  router.push({ name: 'Login' });
};
</script>

<template>
  <v-container>
    <v-card class="mx-auto mt-5" max-width="600">
      <v-card-title class="d-flex align-center">
        <v-icon large left class="mr-2">mdi-account-circle</v-icon>
        <div>
          <h2 class="mb-0">{{ $t('Settings') }}</h2>
          <div v-if="store.state.user" class="text-subtitle-1 text-grey">
            {{ store.state.user.name || store.state.user.username || store.state.user.email }} 
            <v-chip size="x-small" color="primary" class="ml-2" v-if="store.state.user.role">
              {{ $t(store.state.user.role) }}
            </v-chip>
          </div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list>
          <v-list-item to="/inspectionpoints?case=658aa8898db3c04600000142" prepend-icon="mdi-format-list-bulleted">
            <v-list-item-title>{{ $t("Inspection Points") }} (Demo Case)</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="logout" prepend-icon="mdi-logout">
          {{ $t('Logout') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>
